
    import { defineComponent } from 'vue';
    import { mapGetters } from 'vuex';
    import UserService from './user.service'
    import { getRoles } from '@/services/config';
import { ToastFactory } from '@/utils/ToastFactory';
    const userService = new UserService();
    
    export default defineComponent({
        name: 'ListUsers',
        data(){
            return{
                TotalUsers: 0,
                users:[],
                userInfo: {} as any,
                isAdmin: getRoles(),
                params:{ name: '', page: 0, size: 6, total: 0 },
                filters: null as any,
    
                status: ['Ativa', 'Aguardando ativação', 'Bloqueada', 'Desativada']
            }
        },
    
        computed: {
            ...mapGetters({
                storeUsers: 'users/getUsers',
                storeUserInfo: 'users/getUserInfo'
            }),
        },
    
        methods:{

            paginate(event: {page: number, rows: number}): void{
                this.getUsers(this.params.name, event.page, event.rows);
            },
    
            getUsers(name: string, page: number, size: number){
                userService.getAllUsers({name, page, size}).then(() => {
                    this.users = this.storeUsers.content;
                    this.params.total = this.storeUsers.total;
                });
            },
    
            getAllUsersDatabase(page: number, size: number){
                userService.getAllUsers({page, size}).then(() => {
                    this.TotalUsers = this.storeUsers.total;
                });
            },
    
            usersPaginate(): void {
                const params = this.params.page;
                const size = this.params.size;
                const name = this.params.name;
                this.getUsers(name, params, size);
            },
    
            deleteUser(id: any): void{
                userService.deleteUser(id).then(() => {
                    this.$toast.add(ToastFactory.success(this.$t('toast.sucessUserDelete')));
                    this.usersPaginate();
                    this.getAllUsersDatabase(this.params.page, this.params.size)
                }).catch(() => {
                    this.$toast.add(ToastFactory.error(this.$t('toast.errorUserDelete')));
                });
            },
    
            confirmDelete(id: any): void{
                this.$confirm.require({
                    header: this.$t('user.delete'),
                    message: this.$t('org.confirmDelete'),
                    accept: () => {
                        this.deleteUser(id);
                    },
                    reject: () => {
                        console.log('reject');
                    }
                });
            },
    
            userType(status: string){
                switch (status) {
                    case 'ADMIN':
                        return navigator.language === 'pt-BR' ? 'Administrador' : 'Administrator';
                    case 'ADMIN_IOSI':
                        return navigator.language === 'pt-BR' ? 'Administrador IOSI' : 'IOSI Administrator';
                    case 'CLIENT':
                        return navigator.language === 'pt-BR' ? 'Cliente' : 'Client';
                    case 'USER':
                        return navigator.language === 'pt-BR' ? 'Usuário' : 'User';
                    default:
                        return navigator.language === 'pt-BR' ? 'Usuário' : 'User';
                }
            },
        },
        
        mounted(){
            this.usersPaginate();
            this.getAllUsersDatabase(this.params.page, this.params.size)
        }
    });
    